import { useState } from "react";
import styled from "styled-components";
import { getLocale } from "react-i18nify";

import {
  Box,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  TextField
} from "@mui/material";

import font from "src/styles/font";
import useDeviceSize from "src/hooks/useDeviceSize";

const TextLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: var(--secondary-color);
  margin-bottom: 20px;
`;

const WrapperTextfield = styled.div`
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  /* .MuiOutlinedInput-input {
    background: #fff;
    border-radius: 24px;
    padding: 16px;
  } */
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  .MuiInputBase-inputMultiline {
    ::-webkit-scrollbar {
      width: 7px;
      height: 5px;
      display: none;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: var(--grey-color);
      border-radius: 100px;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: var(--grey-color);
    }
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
  }
`;

const AddComponent = ({
  type,
  docType,
  dataSearch,
  setDataSearch,
  suggestDescList,
  setSuggestDescList,
  textDesc,
  setTextDesc,
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const [deviceWidth] = useDeviceSize();

  return (
    <>
      <Box
        sx={{
          width: "100%",
          pb: 3.5,
          position: "sticky",
          top: 0,
          backgroundColor: "var(--white-color)",
          zIndex: 2
        }}
      >
        <TextLabel>หมายเหตุสินค้า</TextLabel>

        <WrapperTextfield>
          <TextField
            variant="outlined"
            multiline
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            rows={deviceWidth <= 835 && isFocus ? 8 : 3} // ขยาย 8
            fullWidth
            sx={{
              ".MuiOutlinedInput-input": {
                lineHeight: 1.8,
              },
            }}
            inputProps={{ maxLength: type === "remark" && 400 }}
            value={textDesc}
            onChange={(e) => setTextDesc(e.target.value)}
            helperText={type === "remark" && (
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {textDesc?.length}/400
              </Box>
            )}
            error={type === "remark" && textDesc?.length > 400}
          />
        </WrapperTextfield>
      </Box>

      {docType === "product" && (
        <Box sx={{ width: "100%" }}>
          <FormControl sx={{ width: "100%", mb: 2.5 }}>
            <FormLabel
              id="product-type-radio-group-label"
              sx={{
                fontSize: font.size.md,
                fontWeight: 400,
                color: "var(--secondary-color)",
                mb: 1.5,
                "&.Mui-focused": {
                  color: "var(--secondary-color)",
                },
              }}
            >
              ประเภทสินค้า
            </FormLabel>

            <RadioGroup
              row
              aria-labelledby="product-type-radio-group-label"
              name="product-type-radio-group"
              sx={{
                ml: "-10px",
                width: "calc(100% + 10px)",
                fontSize: font.size.sm,
                color: "var(--secondary-color)",
              }}
              value={dataSearch.filter}
              onChange={(e) => {
                setDataSearch((prev) => ({
                  ...prev,
                  filter: e.target.value,
                }));
              }}
            >
              <FormControlLabel
                value="floor"
                sx={{
                  flex: "0 0 50%",
                  width: "50%",
                  m: 0,
                  "&.MuiRadio-root": {
                    width: "auto",
                  },
                }}
                control={
                  <Radio
                    sx={{
                      p: 1,
                      color: "var(--primary-color)",
                      "&.Mui-checked": {
                        color: "var(--primary-color)",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                  />
                }
                label={getLocale() === "th" ? "งานพื้น" : "งานผนัง"}
              />

              <FormControlLabel
                value="wall"
                sx={{
                  flex: "0 0 50%",
                  width: "50%",
                  m: 0,
                  "&.MuiRadio-root": {
                    width: "auto",
                  },
                }}
                control={
                  <Radio
                    sx={{
                      p: 1,
                      color: "var(--primary-color)",
                      "&.Mui-checked": {
                        color: "var(--primary-color)",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                  />
                }
                label={getLocale() === "th" ? "งานผนัง" : "งานผนัง"}
              />

              <FormControlLabel
                value="color"
                sx={{
                  flex: "0 0 50%",
                  width: "50%",
                  m: 0,
                  "&.MuiRadio-root": {
                    width: "auto",
                  },
                }}
                control={
                  <Radio
                    sx={{
                      p: 1,
                      color: "var(--primary-color)",
                      "&.Mui-checked": {
                        color: "var(--primary-color)",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                  />
                }
                label={getLocale() === "th" ? "งานสี" : "งานสี"}
              />

              <FormControlLabel
                value="produce"
                sx={{
                  flex: "0 0 50%",
                  width: "50%",
                  m: 0,
                  "&.MuiRadio-root": {
                    width: "auto",
                  },
                }}
                control={
                  <Radio
                    sx={{
                      p: 1,
                      color: "var(--primary-color)",
                      "&.Mui-checked": {
                        color: "var(--primary-color)",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                  />
                }
                label={getLocale() === "th" ? "งานสั่งผลิต" : "งานสั่งผลิต"}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      )}

      <Box>
        <FormControl sx={{ width: "100%" }}>
          <FormLabel
            id="suggest-product-checkbox-group-label"
            sx={{
              fontSize: font.size.md,
              fontWeight: 400,
              color: "var(--secondary-color)",
              mb: 1.5,
              "&.Mui-focused": {
                color: "var(--secondary-color)",
              },
            }}
          >
            {docType === "product" ? `แนะนำรายละเอียดสินค้า` : `แนะนำรายละเอียด`}
          </FormLabel>

          <FormGroup
            row
            aria-labelledby="suggest-product-checkbox-group-label"
            name="suggest-product-checkbox-group"
            sx={{
              ml: "-10px",
              width: "calc(100% + 10px)",
              fontSize: font.size.sm,
              color: "var(--secondary-color)",
              "& .MuiFormControlLabel-root": {
                m: 0,
                mb: 1,
                alignItems: "flex-start",
                "&.MuiRadio-root": {
                  width: "auto",
                },
                "& .MuiFormControlLabel-label": {
                  pt: 1,
                },
                ":last-child": {
                  mb: 0,
                }
              },
            }}
          >
            {/* // ! map item */}
            {suggestDescList.map((item, index) => (
              <FormControlLabel
                key={`suggest-${item?.category}-desc-${index}`}
                label={`${item?.description_text}`}
                sx={{
                  width: "100%"
                }}
                control={
                  <Checkbox
                    sx={{
                      p: 1,
                      color: "var(--primary-color)",
                      "&.Mui-checked": {
                        color: "var(--primary-color)",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                    value={item?.description_text}
                    checked={item?.isSelect}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setTextDesc((prev) => prev === "" ? `${e.target.value}` : `${prev}\n${e.target.value}`);
                      }
                      setSuggestDescList((prev) => {
                        return prev.map((val) => {
                          if (item._id === val._id) {
                            val.isSelect = e.target.checked
                          }
                          return val
                        })
                      })
                    }}
                    disabled={type === "remark" && textDesc?.length >= 400}
                  />
                }
              />
            ))}
          </FormGroup>
        </FormControl>
      </Box>
    </>
  );
};

export default AddComponent;
